import { CarrierVisitAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/carrier-visit-allocation-rules.view-store'
import { GlobalAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/global-allocation-rules.view-store'
import { CarrierVisitOverviewViewStore } from '@yard/pages/YardSetup/stores/carrier-visit-overview.viewstore'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { YardLeftDrawer } from '../../molecules/YardLeftDrawer'
import { CarrierVisitOverview } from './CarrierVisitOverview'

interface Props {
  yardViewStore: YardViewStore
  carrierVisitOverviewViewStore: CarrierVisitOverviewViewStore
  carrierVisitAllocationRulesViewStore: CarrierVisitAllocationRulesViewStore
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
}

export const CarrierVisitOverviewDrawer: FC<Props> = observer(props => {
  const { yardViewStore, carrierVisitOverviewViewStore } = props

  return (
    <YardLeftDrawer
      open={carrierVisitOverviewViewStore.isOverviewOpen && yardViewStore.isViewMode}
      onClose={() => carrierVisitOverviewViewStore.setOverviewOpen(false)}
      fullHeight
    >
      <CarrierVisitOverview {...props} />
    </YardLeftDrawer>
  )
})
